// src/components/common/Breadcrumb.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

export interface Crumb {
    name: string;
    path: string;
}

const Breadcrumb: React.FC<{ items: Crumb[] }> = ({ items }) => (
    <nav className="gh-crumb" aria-label="현재 위치">
        {items.map((item, i) => {
            const last = i === items.length - 1;
            return (
                <React.Fragment key={item.path}>
                    {last ? (
                        <span className="gh-crumb__current" aria-current="page">
                            {item.name}
                        </span>
                    ) : (
                        <Link to={item.path}>{item.name}</Link>
                    )}
                    {!last && <Icon name="chevronRight" size={12} strokeWidth={2.4} />}
                </React.Fragment>
            );
        })}
    </nav>
);

export default Breadcrumb;
